import {
  SET_PASSWORD_EDIT_CP, SET_PASSWORD_EDIT_NP, SET_PASSWORD_EDIT_RNP,
  SET_PASSWORD_CLEAR_FORM
} from "../actions/set_password_actions";


const initialState = {
  current_password: '',
  new_password: '',
  re_new_password: ''
};


export const setPasswordReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PASSWORD_EDIT_CP: {
      return {
        ...state,
        current_password: action.current_password
      }
    }
    case SET_PASSWORD_EDIT_NP: {
      return {
        ...state,
        new_password: action.new_password
      }
    }
    case SET_PASSWORD_EDIT_RNP: {
      return {
        ...state,
        re_new_password: action.re_new_password
      }
    }
    case SET_PASSWORD_CLEAR_FORM: {
      return {
        ...state,
        current_password: '',
        new_password: '',
        re_new_password: ''
      }
    }
    default:
      return state;
  }
}
